// Givsum 3.0 — Clean-slate Webpack entrypoint
// No Sprockets dependency. Only loads what's needed via npm/Webpack.

// Rails UJS (remote forms, CSRF, method override)
import Rails from "@rails/ujs"
if (!window._rails_loaded) Rails.start()

// Bootstrap 5 JS (from npm — not the gem/Sprockets copy)
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// Toast notifications — global so any controller can call window.Gv3Toast.success/error/warning without importing it
import GvToast from "../lib/gv_toast"
window.Gv3Toast = GvToast

// ActionCable channels (WebSocket support)
import "channels"

// Stimulus controllers + StimulusReflex (existing loader)
import "controllers"

// StimulusReflex config (CableReady + StimulusReflex initialization)
import "config"

// ActiveStorage (direct uploads)
require("@rails/activestorage").start()

// Timeago — register on the existing Stimulus application (created by controllers/application.js)
import { application } from "controllers/application"
import Timeago from "stimulus-timeago"
application.register("timeago", Timeago)
